// Client
import React, { useState } from "react";
import { getChallengeFromServer, toServerCreateCredentials } from "./Server";
import { styles } from "./styles";

const FirstLogin = ({ email }) => {
  const [stage, setStage] = useState("usernamePassword");
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);

  const handleUsernamePasswordSubmit = (e) => {
    e.preventDefault();
    setStage("bankOtp");
  };

  const handleSmsOtpSubmit = (e) => {
    e.preventDefault();
    setStage("bioAuth");
  };

  const handleGoToBank = (e) => {
    e.preventDefault();
    setStage("bank");
  };

  const createBiometricsCredentials = async () => {
    // Check for WebAuthn support
    if (!window.PublicKeyCredential) {
      alert("Biometric authentication is not supported by this browser.");
      return;
    }

    const appleVerify =
      window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
    console.log("foo: appleVerify: ", appleVerify);

    // Create a new credential
    try {
      const challenge = getChallengeFromServer(email);

      const publicKey = {
        // The `challenge` is a random or pseudo-random value generated by the server, used to prevent replay attacks.
        challenge,

        // The `rp` (relying party) object contains information about your application.
        rp: {
          name: "Trustly", // The name of your application or service.
          id: window.location.hostname, // The hostname of your application. This must match the domain name where the credential is created.
        },

        // The `user` object contains information about the end user.
        user: {
          id: new Uint8Array(16), // This is a unique identifier for the user. It should be a random, unique byte sequence encoded in Uint8Array.
          name: "nisse@gmail.com", // The user's account name or email address in your application.
          displayName: "Nisse Doe", // A human-readable name for the user, used for display purposes.
        },

        // `pubKeyCredParams` specifies the type of public key credential to create.
        pubKeyCredParams: [
          {
            type: "public-key", // Indicates a public key credential.
            alg: -7, // The cryptographic algorithm to use. -7 stands for the ES256 algorithm (ECDSA with SHA-256).
          },
        ],

        // `timeout` specifies the time in milliseconds the user has to complete the action.
        timeout: 60000, // 60 seconds timeout for the user to complete the biometric check or security key action.

        // `authenticatorSelection` specifies the requirements regarding the authenticator used.
        authenticatorSelection: {
          authenticatorAttachment: "platform", // Specifies that the authenticator should be a platform authenticator (e.g., built-in biometrics or a screen lock).
          requireResidentKey: false, // If set to true, the authenticator must store the key pair on the device itself.
          userVerification: "discouraged", // Indicates the preference for user verification. If set to "required", it mandates biometric or PIN verification.
        },

        // `attestation` conveys the level of attestation required. 'direct' means the authenticator will provide attestation information.
        attestation: "direct",
      };

      const credential = await navigator.credentials.create({ publicKey });

      // console.log("foo: credential: ", credential);

      await toServerCreateCredentials(email, credential);

      setShowSuccessMessage(true);

      setTimeout(() => {
        setStage("bank");
        setShowSuccessMessage(false); // Hide the success message
      }, 2000);

      // alert("Biometric authentication enabled successfully.");

      setStage("bank");
    } catch (err) {
      console.error("Error during biometric registration: ", err);
      alert("Failed to enable biometric authentication. " + err);
    }
  };

  if (showSuccessMessage) {
    return (
      <div style={styles.container}>
        <h1 style={styles.header}>
          Biometric authentication enabled successfully.
        </h1>
        <div style={styles.checkmark}>
          &#x2714; {/* Unicode character for checkmark */}
        </div>
      </div>
    );
  }

  let subject = "";
  if (stage === "usernamePassword") {
    subject = "Login to you bank";
  } else if (stage === "bankOtp") {
    subject = "Enter your bank two step pass";
  } else if (stage === "bioAuth") {
    subject = "Do you want to speed up login next time you login?";
  } else if (stage === "bank") {
    subject = "Choose account";
  }

  return (
    <div style={styles.container}>
      <h1 style={styles.header}>{subject}</h1>

      {stage === "usernamePassword" && (
        <form onSubmit={handleUsernamePasswordSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="Username"
            value="john"
            style={styles.input}
          />
          <input
            type="password"
            placeholder="Password"
            value="12345"
            style={styles.input}
          />
          <button type="submit" style={styles.button}>
            Submit
          </button>
        </form>
      )}

      {stage === "bankOtp" && (
        <form onSubmit={handleSmsOtpSubmit} style={styles.form}>
          <input
            type="text"
            placeholder="SMS OTP"
            value="123456"
            style={styles.input}
          />
          <button type="submit" style={styles.button}>
            Submit
          </button>
        </form>
      )}

      {stage === "bioAuth" && (
        <>
          <button onClick={createBiometricsCredentials} style={styles.button}>
            Create Biometric Authentication
          </button>
          <button onClick={handleGoToBank} style={styles.secondaryButton}>
            Not right now
          </button>
        </>
      )}

      {stage === "bank" && (
        <div style={{ ...styles.form, alignItems: "flex-start" }}>
          <div style={styles.bankAccount}>Bank account 1</div>
          <div style={styles.bankAccount}>Bank account 2</div>
        </div>
      )}
    </div>
  );
};

export default FirstLogin;
